<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h2 class="modal-title" id="modal-basic-title">
      @if (!description) {
        {{ 'setting-add-new-value-title-modal' | translate }} {{ parameter }}
      } @else {
        {{ 'setting-add-new-description-title-modal' | translate }} {{ parameter }}
      }
    </h2>
    <button type="button" class="modal-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body justify-content-center">
    @if (!dico) {
      <div class="d-flex flex-column justify-content-center align-items-center" id="inputs">
        @for (control of formArray.controls; track control; let i = $index) {
          <div>
            <input class="form-control" placeholder="{{ 'setting-form-value' | translate }}" [formControl]="getControl(i)">
            @if (formArray.controls[i].invalid && formArray.controls[i].dirty) {
              <div class="alert alert-danger">
                @if (formArray.controls[i].errors?.['required']) {
                  <div>{{ 'setting-form-error-required' | translate }}</div>
                }
                @if (ltocompare && formArray.controls[i].errors?.['exist']) {
                  <div>{{ 'setting-form-error-already-exist' | translate }}</div>
                }
                @if (formArray.controls[i].errors?.['whitespace']) {
                  <div>{{ 'setting-form-error-invalid-value' | translate }}</div>
                }
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <div class="d-flex flex-column justify-content-center align-items-center" id="inputs">
        @for (i of getLengtMapForm(); track i) {
          <div class="d-flex flex-column">
            <div class="d-flex flex-row">
              <input class="form-control keyF" placeholder="{{ 'setting-form-key' | translate }}" [formControl]="getKey(i)">
              <h3> : </h3>
              <input class="form-control valueF" placeholder="{{ 'setting-form-value' | translate }}" [formControl]="getControl(i)">
            </div>
            <div class="d-flex flex-row justify-content-between align-items-center">
              @if (formKey.controls[i].invalid && formKey.controls[i].dirty) {
                <div class="alert alertmap alert-danger">
                  @if (formKey.controls[i].errors?.['required']) {
                    <div>{{ 'setting-form-error-required' | translate }}</div>
                  }
                  @if (ltocompare && formKey.controls[i].errors?.['exist']) {
                    <div>{{ 'setting-form-error-already-exist' | translate }}</div>
                  }
                  @if (formKey.controls[i].errors?.['whitespace']) {
                    <div>{{ 'setting-form-error-invalid-value' | translate }}</div>
                  }
                </div>
              }
              @if (formArray.controls[i].invalid && formArray.controls[i].dirty) {
                <div class="alert alertmap alert-danger">
                  @if (formArray.controls[i].errors?.['required']) {
                    <div>{{ 'setting-form-error-required' | translate }}</div>
                  }
                  @if (formArray.controls[i].errors?.['whitespace']) {
                    <div>{{ 'setting-form-error-invalid-value' | translate }}</div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
      @if (!onlyone) {
        <div class="d-flex flex-row justify-content-center align-items-center" type="button" (click)="addnewForm()">
          <img src="assets/icons/ic_add.svg">
          <h5>{{ 'setting-add-new-other-value' | translate }}</h5>
        </div>
      }
    }
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary" [disabled]="oneInvalid()"
        (click)="getAllValue();c('Save click');">{{ 'confirm' | translate }}</button>
    </div>
  </div>
</ng-template>

<div class="d-flex flex-row justify-content-center align-items-center addvalue" type="button"
  (click)="open({ content: content })">
  <img src="assets/icons/ic_add.svg">
  <h5>
    @if (!description) {
      {{ 'setting-add-new-value' | translate }}
    } @else {
      {{ 'setting-add-new-description' | translate }}
    }
  </h5>
</div>